// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__23rfE","title":"AfterFrontImage_title__jlkBb"};